import {ComponentType} from 'react';
import type {LucideIcon} from 'lucide-react';
import Dashboard from 'views/Dashboard';
import LoginPage from 'views/LoginPage';
import LogoutPage from './views/LogoutPage';
import SelectOrganisationPage from './views/SelectOrganisationPage';
import UsersPage from './views/UsersPage';
import UserDetailPage from './views/UserDetailPage';
import OrganisationsPage from './views/OrganisationsPage';
import OrganisationDetailPage from './views/OrganisationDetailPage';
import DuplicateUsersPage from './views/DuplicateUsersPage';
import OrphanedFilesPage from './views/OrphanedFilesPage';
import SubscriptionsPage from './views/SubscriptionsPage';

// Modern icons with lucide-react
import {LayoutDashboard, Users, Building2, UserX, FileX, CreditCard} from 'lucide-react';

export interface RouteConfig {
  path: string;
  name: string;
  icon?: LucideIcon;
  component: ComponentType;
  layout: '/admin' | '/admin/auth';
  hideInSidebar?: boolean;
}

const routes: RouteConfig[] = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: LayoutDashboard,
    component: Dashboard,
    layout: '/admin',
  },
  {
    path: '/users',
    name: 'Users',
    icon: Users,
    component: UsersPage,
    layout: '/admin',
  },
  {
    path: '/users/:userId',
    name: 'User Details',
    component: UserDetailPage,
    layout: '/admin',
    hideInSidebar: true,
  },
  {
    path: '/duplicate-users',
    name: 'Duplicate Users',
    icon: UserX,
    component: DuplicateUsersPage,
    layout: '/admin',
  },
  {
    path: '/organisations',
    name: 'Organisations',
    icon: Building2,
    component: OrganisationsPage,
    layout: '/admin',
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    icon: CreditCard,
    component: SubscriptionsPage,
    layout: '/admin',
  },
  {
    path: '/orphaned-files',
    name: 'Orphaned Files',
    icon: FileX,
    component: OrphanedFilesPage,
    layout: '/admin',
  },
  {
    path: '/organisations/:orgId',
    name: 'Organisation Details',
    component: OrganisationDetailPage,
    layout: '/admin',
    hideInSidebar: true,
  },
  {
    path: '/login-page',
    name: 'Login Page',
    component: LoginPage,
    layout: '/admin/auth',
    hideInSidebar: true,
  },
  {
    path: '/select-organisation',
    name: 'Select Organisation',
    component: SelectOrganisationPage,
    layout: '/admin/auth',
    hideInSidebar: true,
  },
  {
    path: '/logout',
    name: 'Logout Page',
    component: LogoutPage,
    layout: '/admin/auth',
    hideInSidebar: true,
  },
];

export default routes;
